import angular from 'angular';
import { isEmptyHtmlField } from '@/shared/utils/validationHelpers';

angular.module('commonServices').filter('isEmpty', function() {
  return function(input) {
    if (typeof input === 'undefined' || input === null) return true;
    if (angular.isString(input) && isEmptyHtmlField(input)) return true;
    if (angular.isString(input)) return input.length === 0;
    if (angular.isArray(input)) return input.length === 0;
    if (angular.isObject(input)) return angular.equals(input, {});
    return true;
  };
});
